import { useState } from "react";
import { endpoints } from "../../hooks/endpoints";
import {
  getToken,
  hasHyphenAtEdges,
  isEnglishOrHyphen,
} from "../../hooks/utils";
import { TutorFormDataI } from "./TutorRegistration";

const ChooseTutotrSubdomain = ({
  formData,
  handlePrev,
  handleNext,
  handleChange,
}: {
  formData: TutorFormDataI;
  handlePrev: () => void;
  handleNext: () => void;
  handleChange: (e: any) => void;
}) => {
  const [isPending, setIsPending] = useState<boolean>(false);
  const [error, setError] = useState("");
  const handleCheckSubdomain = async (e) => {
    e.preventDefault();
    try {
      if (!isEnglishOrHyphen(formData.subdomain)) {
        return setError("يرجى استخدام حروف انجليزية او علامة - فقط");
      }
      if (hasHyphenAtEdges(formData.subdomain)) {
        return setError("لا يمكن استخدام علامة - في البداية او النهاية");
      }
      setIsPending(true);
      setError("");
      const response = await fetch(endpoints.checkSubdomain, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: getToken(),
        },
        body: JSON.stringify({
          subdomain: formData.subdomain,
          profile_pic: formData.profile_pic,
          logo: formData.logo,
        }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw Error(data.data);
      }

      handleNext();
    } catch (e) {
      console.error(e.message);
      setError(e.message);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <form onSubmit={handleCheckSubdomain} className="text-right">
      <h4 className="p-2 mb-4 text-xl mx-auto border-b-2 border-(--primary-color-light) w-fit">
        إختر إسم المنصة
      </h4>

      <p className="text-red-600 text-sm text-start mb-4">
        ملاحظة: إسم المنصة هو اللينك الخاص بالمنصة و يمكن أن يحتوي على أحرف
        باللغة الإنجليزية فقط بدون مسافات أو نقط
      </p>

      <div className="mb-4">
        <label className="block font-medium mb-1">إسم المنصة</label>
        <input
          dir="ltr"
          type="text"
          name="subdomain"
          className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary text-right"
          value={formData.subdomain}
          onChange={handleChange}
          disabled={isPending}
          required
        />
      </div>

      <p className="text-center">اللينك النهائي للمنصة هو</p>

      <p className="text-center text-primary font-bold text-xl mb-4">
        {formData.subdomain ? (
          `${formData.subdomain}.qashqool.com`
        ) : (
          <span dir="ltr">[name].qashqool.com</span>
        )}
      </p>

      <div className="flex justify-center gap-4 flex-wrap">
        <button
          type="button"
          className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 disabled:opacity-50"
          onClick={handlePrev}
          disabled={isPending}
        >
          رجوع
        </button>

        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 disabled:opacity-50"
          disabled={isPending}
        >
          {isPending ? "إنشاء المنصة ..." : "إنشاء المنصة"}
        </button>
      </div>

      {!!error && (
        <div className="bg-red-100 text-red-800 border border-red-300 rounded-lg w-full mt-4 p-3 text-center">
          {error}
        </div>
      )}
    </form>
  );

  // return (
  //   <form onSubmit={handleCheckSubdomain}>
  //     <h4
  //       className="p-2 mb-4 mx-auto"
  //       style={{
  //         width: "fit-content",
  //         borderBottom: "2px solid #673de6",
  //       }}
  //     >
  //       إختر إسم المنصة
  //     </h4>
  //     <p className="text-end text-danger">
  //       ملاحظة: إسم المنصة هو اللينك الخاص بالمنصة و يمكن أن يحتوي على أحرف
  //       باللغة الإنجليزية فقط بدون مسافات أو نقط
  //     </p>
  //     <div className="mb-3">
  //       <label className="form-label">إسم المنصة</label>
  //       <input
  //         dir="ltr"
  //         type="text"
  //         name="subdomain"
  //         className="form-control"
  //         value={formData.subdomain}
  //         onChange={handleChange}
  //         disabled={isPending}
  //         required
  //       />
  //     </div>
  //     <p className="text-center">اللينك النهائي للمنصة هو</p>
  //     <p className="text-center text-ea-primary fw-bold mb-4 fs-4">
  //       {formData.subdomain ? (
  //         `${formData.subdomain}.qashqool.com`
  //       ) : (
  //         <span dir="ltr">[name].qashqool.com</span>
  //       )}
  //     </p>
  //     <button
  //       type="button"
  //       className="btn btn-secondary rounded-ea me-2"
  //       onClick={handlePrev}
  //       disabled={isPending}
  //     >
  //       رجوع
  //     </button>
  //     <button
  //       type="submit"
  //       className="btn btn-success rounded-ea"
  //       disabled={isPending}
  //     >
  //       {isPending ? "إنشاء المنصة ..." : "إنشاء المنصة"}
  //     </button>
  //     {!!error && (
  //       <div
  //         className="alert alert-danger rounded-ea w-100 mt-3 text-center"
  //         role="alert"
  //       >
  //         {error}
  //       </div>
  //     )}
  //   </form>
  // );
};

export default ChooseTutotrSubdomain;
